import React, { useEffect, useState } from "react";
import { Button, Divider, Form, Modal, Progress, Row, Spin } from "antd";
import "./style.scss";
import { httpService } from "../../../../services/httpService.service";
import uploadIcon from "../../../../Assets/svg/uploadIcon.svg";
import { useFilePreview } from "../../completed/ReportingList/Download";
import cancelX from "../../../../Assets/svg/cancelXbutton.svg";
import { formatDate } from "../../../../services/helpFunctions/formatDateAndTime";
import {
  getIpCompleteness,
  getCompletenessColor,
} from "../../../../services/helpFunctions/ipCompleteness";
const PreviewModal = ({ visible, record, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [ipPlanCard, setIpPlanCard] = useState({});
  const { previewFiles } = useFilePreview();

  useEffect(() => {
    if (record) {
      setLoading(true);
      const apiIpPlan = `/api/IPPlan/getIPPlan?id=${record}`;

      httpService.get(
        apiIpPlan,
        (res) => {
          setIpPlanCard(res.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
    }
  }, [record]);

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  function getMonthName(monthNumber) {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    if (monthNumber < 1 || monthNumber > 12) {
      throw new Error("Invalid month number");
    }

    return monthNames[monthNumber - 1];
  }

  const checkStatus = (statusText) => {
    let className = "";
    let fill = "";
    let text = "";

    switch (Number(statusText)) {
      case 1:
        className = "discussion";
        fill = "var(--system-yellow-warning, #AA1A5F)";
        text = "Discussion";
        break;
      case 2:
        className = "documentReview";
        fill = "var(--system-yellow-warning, #FC9403)";
        text = "Document Review";
        break;
      case 3:
        className = "prePlanningPhase";
        fill = "var(--Primary-Blueberry-700, #325899)";
        text = "Pre Planning Phase";
        break;
      case 4:
        className = "dataCollection";
        fill = "#3B81FE";
        text = "Data Collection";
        break;
      case 5:
        className = "closed";
        fill = "#555555";
        text = "Closed";
        break;
      default:
        className = "noStatus";
        fill = " rgba(172, 12, 12, 0.777)";
        text = "No status";
        break;
    }

    return (
      <div className={className}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8px"
          height="8px"
          viewBox="0 0 9 9"
        >
          <circle cx="4.5" cy="4.27344" r="4" fill={fill} />
        </svg>
        <span>{text}</span>
      </div>
    );
  };

  const completeness = getIpCompleteness(ipPlanCard);

  return (
    <Modal
      title={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src={cancelX}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={onCancel}
              alt="cancelX"
            />
          </div>
          <h2 className="modalHeader">Preview IP Plan Card</h2>
        </>
      }
      open={visible}
      closable={false}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      {
        <Spin spinning={loading}>
          <Form form={form} layout="vertical">
            <div className="container">
              <div className="row">
                <Form.Item
                  name="id"
                  className="col-12 col-lg-6 col-md-6"
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      IP Plan Card Identifier
                    </span>
                  }
                >
                  <p className="previewText">{ipPlanCard?.identifier}</p>
                </Form.Item>
                {ipPlanCard?.ipPlanCode && (
                  <Form.Item
                    name="id"
                    label={
                      <span style={{ fontWeight: "bold" }}>
                        IP Project Code
                      </span>
                    }
                    className="col-12 col-lg-6 col-md-6"
                  >
                    <p className="previewText">{ipPlanCard?.ipPlanCode}</p>
                  </Form.Item>
                )}
                <p className="modalsHeader1">General Details</p>

                <Form.Item
                  name="ip"
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      Implementing Partner
                    </span>
                  }
                  className="col-12"
                >
                  <p className="previewText">
                    {ipPlanCard?.implementingPartner?.name}
                  </p>
                </Form.Item>
                <Form.Item
                  name="ip"
                  label={<span style={{ fontWeight: "bold" }}>Country</span>}
                  className="col-12 col-lg-6 col-md-6"
                >
                  <p className="previewText">
                    {
                      ipPlanCard?.implementingPartner?.states?.[0]?.country
                        ?.stateName
                    }
                  </p>
                </Form.Item>
                <Form.Item
                  name="ip"
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      Governorate/State
                    </span>
                  }
                  className="col-12 col-lg-6 col-md-6"
                >
                  <p className="previewText">
                    {ipPlanCard?.ipPlanStates
                      ?.map((state) => state?.stateName)
                      .join(", ")}
                  </p>
                </Form.Item>
                {ipPlanCard?.ipPlanCities?.length ? (
                  <Form.Item
                    name="ip"
                    label={
                      <span style={{ fontWeight: "bold" }}>
                        City/Disctrict/Municipality
                      </span>
                    }
                    className="col-12"
                  >
                    <p className="previewText">
                      {ipPlanCard?.ipPlanCities
                        ?.map((city) => city?.name)
                        .join(", ")}
                    </p>
                  </Form.Item>
                ) : (
                  ""
                )}

                <Form.Item
                  name="ip"
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      Assigned to a Field Coordinator
                    </span>
                  }
                  className="col-12 col-lg-6 col-md-6"
                >
                  <p className="previewText">
                    {ipPlanCard?.assignee?.userDetails?.firstName
                      ? `${ipPlanCard?.assignee?.userDetails?.firstName}
                     ${ipPlanCard?.assignee?.userDetails?.lastName}`
                      : ipPlanCard?.assignee?.email}
                  </p>
                </Form.Item>
                <Form.Item
                  name="ip"
                  label={<span style={{ fontWeight: "bold" }}>Clusters</span>}
                  className="col-12 col-lg-6 col-md-6"
                >
                  <p className="previewText">
                    {ipPlanCard?.clusters
                      ?.map((cluster) => cluster?.name)
                      .join(", ")}
                  </p>
                </Form.Item>
                <Form.Item
                  name="ip"
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      General information About On-Site Operations:
                    </span>
                  }
                  className="col-12"
                >
                  <p className="previewText">{ipPlanCard?.generalInfo}</p>
                </Form.Item>
                {ipPlanCard?.planningRound?.programDescription && (
                  <Form.Item
                    name="ip"
                    label={
                      <span style={{ fontWeight: "bold" }}>
                        IP Program Activities Description
                      </span>
                    }
                    className="col-12"
                  >
                    <p className="previewText">
                      {ipPlanCard?.planningRound?.programDescription}
                    </p>
                  </Form.Item>
                )}
                <Form.Item
                  name="ip"
                  label={
                    <span style={{ fontWeight: "bold" }}>Initial Meeting</span>
                  }
                  className="col-12"
                >
                  <p className="previewText">
                    {formatDate(ipPlanCard?.initialMeeting)}
                  </p>
                </Form.Item>
                <p className="modalsHeader1">Assigned to Round</p>
                <Form.Item
                  name="ip"
                  label={<span style={{ fontWeight: "bold" }}>Month</span>}
                  className="col-6"
                >
                  <p className="previewText">
                    {getMonthName(ipPlanCard?.planningRound?.month)}
                  </p>
                </Form.Item>
                <Form.Item
                  name="ip"
                  label={<span style={{ fontWeight: "bold" }}>Year</span>}
                  s
                  className="col-6"
                >
                  <p className="previewText">
                    {ipPlanCard?.planningRound?.year}
                  </p>
                </Form.Item>
                <p className="modalsHeader1">IP Point of Contact</p>
                <div className="contactInfoWrapper">
                  <Row className="w-100">

            
                  <Form.Item
                    name="ip"
                    label={
                      <span style={{ fontWeight: "bold" }}>Contact Name</span>
                    }
                    className="col-12 col-lg-6 col-md-6"
                  >
                    <p className="previewText">
                      {ipPlanCard?.pointOfContact?.name}
                    </p>
                  </Form.Item>
                  {ipPlanCard?.pointOfContact?.email && (
                    <Form.Item
                      name="ip"
                      label={<span style={{ fontWeight: "bold" }}>Email</span>}
                      className="col-12 col-lg-6 col-md-6"
                    >
                      <p className="previewText">
                        {ipPlanCard?.pointOfContact?.email}
                      </p>
                    </Form.Item>
                  )}
                  <Form.Item
                    name="ip"
                    label={<span style={{ fontWeight: "bold" }}>Role</span>}
                    className="col-12 col-lg-6 col-md-6"
                  >
                    <p className="previewText">
                      {ipPlanCard?.pointOfContact?.role}
                    </p>
                  </Form.Item>
                  <Form.Item
                    name="ip"
                    label={
                      <span style={{ fontWeight: "bold" }}>Organization</span>
                    }
                    className="col-12 col-lg-6 col-md-6"
                  >
                    <p className="previewText">
                      {ipPlanCard?.pointOfContact?.organization}
                    </p>
                  </Form.Item>
                  <Form.Item
                    name="ip"
                    label={<span style={{ fontWeight: "bold" }}>Phone</span>}
                    className="col-12 col-lg-6 col-md-6"
                  >
                    <p className="previewText">
                      {ipPlanCard?.pointOfContact?.phone || 'No phone number added'}
                    </p>
                  </Form.Item>
                  {/* {ipPlanCard?.pointOfContact?.skype && (
                    <Form.Item
                      name="ip"
                      label={
                        <span style={{ fontWeight: "bold" }}>
                          Name of the Tool:
                        </span>
                      }
                      className="col-12 col-lg-6 col-md-6"
                    >
                      <p className="previewText">
                        {ipPlanCard?.pointOfContact?.skype}
                      </p>
                    </Form.Item>
                  )} */}
                      </Row>
                </div>

                <Form.Item
                  name="isPostponed"
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      Current IP Status:
                    </span>
                  }
                  className="col-12 mt-4"
                >
                  <p className="previewText styledTitle">
                    {checkStatus(ipPlanCard?.currentIPStatus)}
                  </p>
                </Form.Item>
                {/* F-07 — IP completeness score (read-only, derived from fields) */}
                <Form.Item
                  label={
                    <span style={{ fontWeight: "bold" }}>
                      Completeness ({completeness.band})
                    </span>
                  }
                  className="col-12"
                >
                  <Progress
                    percent={completeness.percent}
                    strokeColor={getCompletenessColor(completeness.percent)}
                  />
                  <span style={{ fontSize: 12, color: "#707073" }}>
                    {completeness.completeCount}/{completeness.totalCount} key
                    fields complete
                  </span>
                </Form.Item>
                {ipPlanCard?.ipPlanFiles?.length > 0 ? (
                  <div className="my-3">
                    <span style={{ fontWeight: "bold" }}>
                      Security plan (recommendations from IP):
                    </span>
                  </div>
                ) : (
                  ""
                )}
                <div className="filesWrapper">
                  {ipPlanCard?.ipPlanFiles?.map((file) => (
                    <div
                      className="fileDetails"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => previewFiles(e, file.fileKey, file.id)}
                    >
                      <div className="fileIcon">
                        <img src={uploadIcon} alt="uploaded" />
                      </div>
                      <div className="fileInfo">
                        <span>{file?.fileName}</span>
                        <p className="mb">
                          {(parseInt(file?.fileSize) / (1024 * 1024)).toFixed(
                            1
                          )}{" "}
                          MB
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                <Divider />
                <div className="button-container">
                  <Button
                    className="inviteButtonTPM"
                    key="cancel"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      }
    </Modal>
  );
};

export default PreviewModal;
